import 'dayjs/locale/de';
import 'dayjs/locale/de-ch';
import 'dayjs/locale/fr';
import 'dayjs/locale/fr-ch';
import 'dayjs/locale/it';
import 'dayjs/locale/it-ch';
import { API_BASE_URL, APP_POOL_CONFIG } from '@synergy/config';
import { CssBaseline, GlobalStyles } from '@mui/material';
import { ENVIRONMENT, POOL_INSTANCE, RELEASE, SENTRY_DSN } from '@synergy/config';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import { createRoot } from 'react-dom/client';
import { initSentry } from '@synergy/utils';
import { theme } from '@synergy/theme-next';

import { App } from './app/app';
import { store } from './store/store';

initSentry({
    dsn: SENTRY_DSN,
    environment: ENVIRONMENT,
    release: RELEASE,
    project: 'shop-frontend',
    poolInstance: POOL_INSTANCE,
});

const headScriptElement = document.createElement('script');

headScriptElement.src = `${API_BASE_URL}/head-script/shop`;
headScriptElement.type = 'text/javascript';

document.head.appendChild(headScriptElement);
document.title = `${APP_POOL_CONFIG.name_short} Shop`;

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(document.getElementById('root')!);
root.render(
    <Provider store={store}>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <GlobalStyles
                styles={theme => ({
                    a: {
                        color: theme.palette.primary.main,
                    },
                })}
            />
            <App />
        </ThemeProvider>
    </Provider>
);
